import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { buildThresholdList } from './helpers';
import { CURRENT_VISIBLE_PRODUCT_ID, LOADED_ITEMS_OFFSET, ROOT_MARGIN } from './';
export const useScrollRestoration = ({ offset = 0, isLoading, accessoryCategory, lio, }) => {
    const location = useLocation();
    const { search } = location;
    const [itemsCount, setItemsCount] = useState(0);
    const lioDefaultState = Object.entries(lio).reduce((acc, item) => {
        return {
            ...acc,
            [item[0]]: '0',
        };
    }, {});
    const searchRef = useRef(search);
    const itemRefs = useRef(new Map()).current;
    const isLoadingRef = useRef(isLoading);
    const currentVisibleRef = useRef(null);
    const productIdFromSessionStorage = sessionStorage.getItem(CURRENT_VISIBLE_PRODUCT_ID) || '';
    const productIdRef = useRef(productIdFromSessionStorage);
    const visibilityThreshold = 0.7;
    const scrollToElementById = useCallback((id = productIdRef.current) => {
        const element = itemRefs.get(id);
        if (!isLoading && element?.current && !currentVisibleRef.current) {
            element.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
    }, [isLoading, itemRefs]);
    useEffect(() => {
        isLoadingRef.current = isLoading;
    }, [isLoading]);
    const updateItemsRef = useCallback((id, el) => {
        itemRefs.set(id, el);
    }, [itemRefs]);
    useEffect(() => {
        setItemsCount(itemRefs.size);
    }, [itemRefs.size]);
    useEffect(() => {
        scrollToElementById();
    }, [scrollToElementById]);
    useEffect(() => {
        const observers = [];
        itemRefs.forEach((value, key) => {
            const observer = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting && entry.intersectionRatio > visibilityThreshold) {
                    currentVisibleRef.current = entry.target;
                    sessionStorage.setItem(CURRENT_VISIBLE_PRODUCT_ID, key);
                    sessionStorage.setItem(LOADED_ITEMS_OFFSET, JSON.stringify({
                        ...lioDefaultState,
                        [accessoryCategory]: offset?.toString(),
                    }));
                }
            }, {
                threshold: buildThresholdList(3),
                rootMargin: ROOT_MARGIN,
            });
            if (value.current) {
                observer.observe(value.current);
                observers.push(observer);
            }
        });
        return () => {
            observers.forEach((observer) => {
                observer.disconnect();
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemRefs, itemsCount, offset]);
    useEffect(() => {
        searchRef.current = search;
    }, [search]);
    return {
        updateItemsRef,
        itemRefs,
    };
};
